/* ═══════════════════════════════════════════════════════
   RUTAM™  —  Theme JS  (assets/rutam-theme.js)
   Cart drawer, cursor, scroll reveal, ATC, nav
   ═══════════════════════════════════════════════════════ */

(function() {
  'use strict';

  /* ── UTILITIES ── */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return (ctx || document).querySelectorAll(sel); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }

  /* ══════════════════════════════════════════
     CURSOR (desktop only)
     ══════════════════════════════════════════ */
  var cursor = $('#cursor');
  var ring   = $('#cursor-ring');
  if (cursor && ring && window.matchMedia('(hover: hover)').matches) {
    var mx=0, my=0, rx=0, ry=0;
    on(document, 'mousemove', function(e) {
      mx = e.clientX; my = e.clientY;
      cursor.style.left = (mx - 4) + 'px';
      cursor.style.top  = (my - 4) + 'px';
    }, { passive: true });
    (function tick() {
      rx += (mx - rx) * 0.12;
      ry += (my - ry) * 0.12;
      ring.style.left = (rx - 18) + 'px';
      ring.style.top  = (ry - 18) + 'px';
      requestAnimationFrame(tick);
    })();
    $$('a, button, .product-card, .principle-card, .system-step, .pillar, .product-upload-zone').forEach(function(el) {
      on(el, 'mouseenter', function() { ring.classList.add('hovered'); });
      on(el, 'mouseleave', function() { ring.classList.remove('hovered'); });
    });
  }

  /* ══════════════════════════════════════════
     SCROLL REVEAL
     ══════════════════════════════════════════ */
  if ('IntersectionObserver' in window) {
    var ro = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) e.target.classList.add('visible');
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    $$('.reveal').forEach(function(el) { ro.observe(el); });
  } else {
    $$('.reveal').forEach(function(el) { el.classList.add('visible'); });
  }

  /* ══════════════════════════════════════════
     CART DRAWER
     ══════════════════════════════════════════ */
  var cartDrawer  = $('#CartDrawer');
  var cartOverlay = $('#CartOverlay');
  var cartClose   = $('#CartClose');
  var cartBody    = $('#CartBody');
  var cartCount   = $$('.header-cart__count, #CartCount');
  var cartTotal   = $('#CartTotal');
  var cartEmpty   = $('#CartEmpty');

  function openCart()  {
    if (cartDrawer) { cartDrawer.classList.add('open'); document.body.style.overflow = 'hidden'; }
    if (cartOverlay) cartOverlay.classList.add('active');
    refreshCart();
  }
  function closeCart() {
    if (cartDrawer) { cartDrawer.classList.remove('open'); document.body.style.overflow = ''; }
    if (cartOverlay) cartOverlay.classList.remove('active');
  }

  on(cartClose,   'click', closeCart);
  on(cartOverlay, 'click', closeCart);
  on(document, 'rutam:cart:open',    openCart);
  on(document, 'rutam:cart:updated', function(e) { refreshCart(); });

  /* Close on Escape */
  on(document, 'keydown', function(e) {
    if (e.key === 'Escape') closeCart();
  });

  /* Fetch cart state from Shopify */
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        updateCartCount(cart.item_count);
        renderCartItems(cart);
        if (cartTotal) {
          cartTotal.textContent = formatMoney(cart.total_price);
        }
      })
      .catch(function(err) { console.warn('Cart fetch error', err); });
  }

  function updateCartCount(count) {
    cartCount.forEach(function(el) { el.textContent = count; });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderCartItems(cart) {
    if (!cartBody) return;
    if (cart.item_count === 0) {
      cartBody.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p></div>';
      return;
    }
    var html = '';
    cart.items.forEach(function(item) {
      html += '<div class="cart-item" data-line="' + item.key + '">';
      html += '  <img class="cart-item__img" src="' + (item.image ? item.image.replace('http:', 'https:') : '') + '" alt="' + item.title + '" loading="lazy">';
      html += '  <div>';
      html += '    <div class="cart-item__title">' + item.product_title + '</div>';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        html += '    <span class="cart-item__variant">' + item.variant_title + '</span>';
      }
      html += '    <div class="cart-item__qty-wrap">';
      html += '      <button class="cart-item__qty-btn" data-action="decrease" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">−</button>';
      html += '      <span class="cart-item__qty">' + item.quantity + '</span>';
      html += '      <button class="cart-item__qty-btn" data-action="increase" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button>';
      html += '    </div>';
      html += '  </div>';
      html += '  <div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>';
      html += '</div>';
    });
    cartBody.innerHTML = html;

    /* Qty buttons */
    $$('.cart-item__qty-btn', cartBody).forEach(function(btn) {
      on(btn, 'click', function() {
        var key = this.getAttribute('data-key');
        var qty = parseInt(this.getAttribute('data-qty'));
        updateCartItem(key, qty);
      });
    });
  }

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartCount(cart.item_count);
      renderCartItems(cart);
      if (cartTotal) cartTotal.textContent = formatMoney(cart.total_price);
    });
  }

  /* ATC buttons (collection pages, homepage) */
  on(document, 'click', function(e) {
    var btn = e.target.closest('.btn-atc') || e.target.closest('.pdp-btn-atc');
        if (!btn) return;
            var varId = btn.getAttribute('data-variant-id');
                if (!varId) { var f = btn.closest('form'); if (f) { var inp = f.querySelector('[name="id"]'); if (inp) varId = inp.value; } }
                    if (!varId) return;
    e.preventDefault();
    btn.classList.add('loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(varId), quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      btn.classList.remove('loading');
      document.dispatchEvent(new CustomEvent('rutam:cart:updated'));
      document.dispatchEvent(new CustomEvent('rutam:cart:open'));
    })
    .catch(function() {
      btn.classList.remove('loading');
      window.location.href = '/cart';
    });
  });

  /* ══════════════════════════════════════════
     INITIAL CART COUNT
     ══════════════════════════════════════════ */
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function(r) { return r.json(); })
    .then(function(cart) { updateCartCount(cart.item_count); })
    .catch(function() {});

})();